/** Recurrence-type picker for an assigned post-it. */
import type { ScheduleType, PostItColor } from '@/types/post-it.types';
import { cn } from '@/lib/utils';
import {
  BORDER_COLOR_MAP,
  POST_IT_SCHEDULE_TYPE_OPTIONS,
} from '@/components/post-its/post-it-configs';
import { getScheduleChipClasses } from '@/components/post-its/post-it-form-utils';

/** Props for {@link ScheduleTypePicker}. */
interface ScheduleTypePickerProps {
  value: ScheduleType | null;
  onChange: (type: ScheduleType) => void;
  color?: PostItColor;
}

/** Recurrence-type picker for an assigned post-it. */
export function ScheduleTypePicker({
  value,
  onChange,
  color = 'jaune',
}: Readonly<ScheduleTypePickerProps>) {
  const borderColor = BORDER_COLOR_MAP[color] || BORDER_COLOR_MAP.jaune;
  return (
    <div className="space-y-1.5">
      <p className="text-xs font-medium uppercase tracking-wide opacity-70">
        Type de planification
      </p>
      <div className="flex flex-wrap gap-1.5">
        {POST_IT_SCHEDULE_TYPE_OPTIONS.map((type) => (
          <button
            key={type.value}
            type="button"
            onClick={() => onChange(type.value)}
            className={cn(
              'flex items-center gap-1.5 px-2.5 py-1.5 rounded-lg text-xs border transition-all',
              borderColor,
              getScheduleChipClasses(color, value === type.value),
              value === type.value && 'shadow-sm',
            )}
          >
            <span>{type.icon}</span>
            <span>{type.label}</span>
          </button>
        ))}
      </div>
    </div>
  );
}
